import React, {useContext, useState, useEffect} from 'react';
import { InputContext } from '../contexts/InputContext';
import { Link } from "react-router-dom";
import { errorMessage } from '../errorHandler';

// ICONOS PROVISTOS POR:
// https://icons.getbootstrap.com/

// MENU OPTIONS
import NotificacionesNuevas from './menu-options/NotificacionesNuevas';
import NotificacionesTodas from './menu-options/NotificacionesTodas';
import CrearNotificacion from './menu-options/CrearNotificacion';
import NotificacionesNotificador from './menu-options/NotificacionesNotificador';
import CambioClave from './menu-options/CambioClave';
import Perfil from './menu-options/Perfil';
import ListaUsuarios from './menu-options/ListaUsuarios';
import CrearUsuario from './menu-options/CrearUsuario';
import CrearApoderado from './menu-options/CrearApoderado';
import Admin from './menu-options/Admin';
import resourcesServices from '../services/resourcesServices';
import FormularioPDF from './menu-options/FormularioPDF';
import Ayuda from './menu-options/Ayuda';
import Apoderados from './menu-options/Apoderados';
import Cedulas from './menu-options/Cedulas';
import ListaObligados from './menu-options/ListaObligados';
import logoTc from "../assets/img/logo-tc.png"

const Menu = () => {
  const [authInformation, setAuthInformation, showSideMenu, setShowSideMenu] = useContext(InputContext);
  const [renderHTML, setRenderHTML] = useState(false)
  const [notificaciones, setNotificaciones] = useState([]);

  useEffect(() => {
    if(authInformation.autenticado === true){
      setRenderHTML(true)
      if(authInformation.rol === "Obligado"){
        obtenerNotificaciones()
      }
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  const obtenerNotificaciones = async () => {
    try {
        const mensajes = await resourcesServices.obtenerResources('notificaciones');
        setNotificaciones(mensajes.data);
      } catch (error) {
        errorMessage(error)
      }
  }

  return (
    <>
      <div className="sidenav-header">
        <i className={`fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-xl-none ${showSideMenu ? '' : 'd-none'}`} aria-hidden="true" id="iconSidenav">x</i>
        <Link className="navbar-brand m-0" to="/" >
          <img src={logoTc} className="img-fluid" alt="main_logo" />
          <div className="ms-1 font-weight-bold">Tribunal de Cuentas</div>
        </Link>
      </div>
      <hr className="horizontal dark mt-0" />
      <div className="collapse navbar-collapse  w-auto " id="sidenav-collapse-main">
         {renderHTML ? (
          <ul className="navbar-nav">
            {
              (authInformation.rol === "Obligado" || authInformation.rol === "Apoderado") && (
                <>
                  <li className="nav-item">
                    <NotificacionesTodas />
                  </li>
                  <li className="nav-item">
                    <NotificacionesNuevas notificaciones={notificaciones} />
                  </li>
                </>
              )
            }
            {
              (authInformation.rol === "Supervisor" || authInformation.rol === "Notificador" || authInformation.rol === "Veedor") && (
                <>
                  {(authInformation.rol === "Notificador") && (
                  <li className="nav-item">
                    <CrearNotificacion />
                  </li>
                  )}
                  <li className="nav-item">
                    <NotificacionesNotificador />
                  </li>
                  {/* <li className="nav-item">
                    <Cedulas />
                  </li> */}
                  
                </>
              )
            }
            {
              (authInformation.rol === "Veedor" || authInformation.rol === "Supervisor" || authInformation.rol === "Notificador") && (
                <li className="nav-item">
                  <ListaUsuarios />
                </li>
              )
            }
            {
              (authInformation.rol === "Admin") && (
                <>
                  <li className="nav-item">
                    <ListaUsuarios />
                  </li>
                  <li className="nav-item">
                    <CrearUsuario />
                  </li>
                  <li className="nav-item">
                    <NotificacionesNotificador />
                  </li>
                  <li className="nav-item">
                    <Admin />
                  </li>
                </>
              )
            }

            {
              (authInformation.rol === "MesaEntrada") && (
                <>
                  <li className="nav-item">
                    <ListaUsuarios />
                  </li>
                  <li className="nav-item">
                    <CrearApoderado />
                  </li>
                  <li className="nav-item">
                    <ListaObligados />
                  </li>
                </>
              )
            }

            <li className="nav-item mt-3">
              <h6 className="ps-4 ms-2 text-uppercase text-xs font-weight-bolder opacity-6">Mi cuenta</h6>
            </li>
            {/* {
              (authInformation.rol === "Obligado") && (
                <li className="nav-item">
                  <Apoderados />
                </li>
              )
            } */}
            <li className="nav-item">
              <Perfil />
            </li>
            <li className="nav-item">
              <CambioClave />
            </li>
            <li className="nav-item">
              <Ayuda />
            </li>
            {/* <li className="nav-item">
              <SignIn />
            </li>
            <li className="nav-item">
              <SignUp />
            </li> */}
          </ul>
         ): (
          <div className='px-3'>
            <div className='m-1'>En este espacio encontrarás todas las comunicaciones oficiales y actualizaciones relevantes.</div>
            <hr className="horizontal dark mt-0" />
            <div className='m-1'>Tu participación activa en este espacio es fundamental para mantenerte informado.</div>
            <hr className="horizontal dark mt-0" />
            <Link className='btn btn-secondary' to={`/registroPublico`} >Registro de Obligado</Link>
            {/* <Link className='btn btn-secondary disable' to={`/`} >Registro de Obligado</Link> */}
          </div>
         )}
      </div>
        {/* <pre>{JSON.stringify(location, null, 2)}</pre> */}
      {/* <div className="sidenav-footer mx-3 ">
        <div className="card card-background shadow-none card-background-mask-secondary" id="sidenavCard">
          <div className="full-background"></div>
          <div className="card-body text-start p-3 w-100">
            <div className="icon icon-shape icon-sm bg-white shadow text-center mb-3 d-flex align-items-center justify-content-center border-radius-md">
              <i className="ni ni-diamond text-dark text-gradient text-lg top-0" aria-hidden="true" id="sidenavCardIcon"></i>
            </div>
            <div className="docs-info">
              <h6 className="text-white up mb-0">Necesita ayuda?</h6>
              <p className="text-xs font-weight-bold">Consulte nuestras preguntas frecuentes</p>
              <a href="https://www.creative-tim.com/learning-lab/bootstrap/license/soft-ui-dashboard" target="_blank" className="btn btn-white btn-sm w-100 mb-0">Preguntas Frecuentes</a>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default Menu;